import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { api } from '../../lib/api';

interface PublicReview {
  id: string;
  rating: number;
  body?: string;
  authorName?: string;
  createdAt: string;
}

export function ReviewWidget() {
  const { tenantSlug } = useParams<{ tenantSlug: string }>();

  const q = useQuery({
    queryKey: ['public-reviews', tenantSlug],
    queryFn: () => api.get<{ data: PublicReview[]; averageRating: number; total: number }>(`/public/reviews/${tenantSlug}`),
  });

  if (q.isLoading) {
    return <div style={{ padding: 16, fontFamily: 'system-ui', fontSize: 14, color: '#64748b' }}>Loading reviews…</div>;
  }
  if (!q.data) return null;

  const { data: reviews, averageRating, total } = q.data;

  return (
    <div style={{ fontFamily: 'system-ui, -apple-system, sans-serif', padding: 16, maxWidth: 600 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 16 }}>
        <span style={{ fontSize: 24, fontWeight: 700 }}>{averageRating.toFixed(1)}</span>
        <span style={{ color: '#fbbf24', fontSize: 18 }}>{'★'.repeat(Math.round(averageRating))}</span>
        <span style={{ color: '#64748b', fontSize: 14 }}>({total} reviews)</span>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        {reviews.map((r) => (
          <div key={r.id} style={{ borderTop: '1px solid #e2e8f0', paddingTop: 12 }}>
            <div style={{ color: '#fbbf24', marginBottom: 4 }}>
              {'★'.repeat(r.rating)}
              {'☆'.repeat(5 - r.rating)}
            </div>
            {r.body && <p style={{ fontSize: 14, margin: '0 0 4px' }}>{r.body}</p>}
            <div style={{ fontSize: 12, color: '#94a3b8' }}>
              {r.authorName ?? 'Anonymous'} · {new Date(r.createdAt).toLocaleDateString()}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
